function detectBrowserDateFormat(): string {
  const date = new Date(2000, 0, 31); // Jan 31, 2000
  const formatted = new Intl.DateTimeFormat(navigator.language, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  }).format(date);

  if (formatted.match(/^31/)) {
    const sep = formatted[2];
    return `dd${sep}MM${sep}yyyy`;
  } else if (formatted.match(/^01/)) {
    const sep = formatted[2];
    return `MM${sep}dd${sep}yyyy`;
  } else if (formatted.match(/^2000/)) {
    const sep = formatted[4];
    return `yyyy${sep}MM${sep}dd`;
  }

  return "dd/MM/yyyy";
}

export { detectBrowserDateFormat };
